import { combineReducers } from 'redux';
import webchat from './webchat';

export default combineReducers({
    webchat,
});
